import React from 'react';
import {FabMenuItem} from './fabMenu';
import * as css from './TicketMenue.css';

interface MenuItemProps {
    item: FabMenuItem;
    isOpen: boolean;
    onRun: (onClick?: () => void) => void;
}

function MenuItem({item, isOpen, onRun}: MenuItemProps): React.ReactElement {
    const {key, label, Icon, danger, onClick} = item;
    return (
        <css.item
            type="button"
            className={danger ? 'danger' : ''}
            tabIndex={isOpen ? 0 : -1}
            onClick={() => onRun(onClick)}
            data-cy={`ticket-fab-${key}`}
        >
            <css.label>{label}</css.label>
            <css.iconCircle><Icon size={22} /></css.iconCircle>
        </css.item>
    );
}

export default MenuItem;
